<template>
  <div class="flex pt-11 lg:pt-26px">
    <router-link class="link mr-28" :to="{name:'investments'}">{{ $t('main') }}</router-link>
    <router-link class="link mr-28" :to="{name:'investments-assets'}">{{ $t('assets') }}</router-link>
    <router-link class="link mr-28" :to="{name:'investments-deals'}">{{ $t('events') }}</router-link>
    <!--    <router-link class="link" :to="{name:'investments-analytics'}">{{ $t('analytics') }}</router-link>-->
    <div class="link ml-auto relative flex items-center"
         v-if="!current_portfolio.dirty && !!portfolios_list.data.length"
         v-on-click-away="hidePopup"
         @click="showActionsPopup = !showActionsPopup">
      <IconBriefcase class="mr-4"/>
      {{ $t('portfolioActions') }}
      <IconChevronSm class="ml-4"/>
      <InvestmentNavigationActions v-show="showActionsPopup"/>
    </div>
  </div>
</template>

<script>
import InvestmentNavigationActions from "@/components/common/Header/HeaderSubNavigation/InvestmentNavigationActions";
import {directive as onClickAway} from "vue-clickaway";
import IconBriefcase from "@/components/icons/IconBriefcase";
import IconChevronSm from "@/components/icons/IconChevronSm";
import {mapState} from "vuex";

export default {
  name: "InvestmentNavigation",
  data() {
    return {showActionsPopup: false}
  },
  directives: {
    onClickAway: onClickAway
  },
  computed:{
    ...mapState('investments/portfolios', ['portfolios_list', 'current_portfolio']),
  },
  methods: {
    hidePopup() {
      setTimeout(() => {
        this.showActionsPopup = false;
      })
    }
  },
  components: {IconChevronSm, IconBriefcase, InvestmentNavigationActions},
  i18n: {
    messages: {
      en: {
        main: 'Main',
        assets: 'Assets',
        events: 'Events',
        analytics: 'Analytics',
        portfolioActions: 'Portfolio actions'
      },
      ru: {
        main: 'Главная',
        assets: 'Бумаги',
        events: 'События',
        analytics: 'Аналитика',
        portfolioActions: 'Действия с портфелем'
      }
    }
  }
}
</script>
